import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './components/Home';
import AboutUs from './components/AboutUs';
import GoldJewellery from './components/GoldJewellery';
import DiamondJewellery from './components/DiamondJewellery';
import GoldRatesDisplay from './components/GoldRatesDisplay';
import ContactUs from './components/ContactUs';
import './App.css';

function App() {
  const [goldRates, setGoldRates] = useState(null);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const updateGoldRates = async () => {
    try {
      setLoading(true);
      
      // Call the Redis-based gold rates API
      const response = await fetch('/api/gold/latest');
      const data = await response.json();
      
      if (data.success) {
        setGoldRates(data.data);
        setLastUpdated(new Date());
        setError(null);
      } else {
        throw new Error(data.error || 'Failed to fetch gold rates');
      }
    } catch (err) {
      console.error('Error fetching gold rates:', err);
      setError('Failed to fetch gold rates. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    updateGoldRates();
    
    // Update every 4 hours during business hours (8 AM - 8 PM)
    const interval = setInterval(() => {
      const now = new Date();
      const hour = now.getHours();
      if (hour >= 8 && hour < 20) {
        updateGoldRates();
      }
    }, 4 * 60 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  const GoldRatePage = () => (
    <main className="main-content tv-container">
      <h1 className="title">Today's Gold Rate in Dubai, UAE</h1>

      <GoldRatesDisplay 
        goldRates={goldRates} 
        loading={loading} 
        error={error}
        onRetry={updateGoldRates}
      />
      
      {lastUpdated && (
        <div style={{ textAlign: 'center', marginTop: '3rem' }}>
          Last updated: {lastUpdated.toLocaleString('en-US', { 
            timeZone: 'Asia/Dubai',
            year: 'numeric', 
            month: 'long', 
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
          })} (Dubai Time)
        </div>
      )}
    </main>
  );

  return (
    <Router>
      <div className="app-container">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/gold-jewellery" element={<GoldJewellery />} />
          <Route path="/diamond-jewellery" element={<DiamondJewellery />} />
          <Route path="/gold-rate" element={<GoldRatePage />} />
          <Route path="/contact" element={<ContactUs />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
